/**
 * element-ui组件按需引入, 并全局注册
 */
import Vue from 'vue';
// 自定义主题 (npm run theme:build)
// import 'element-theme-chalk/element-diy-ui/index.css';
// 国际化
import lang from 'element-ui/lib/locale/lang/zh-CN';
import locale from 'element-ui/lib/locale';

// 组件
import {
    Alert,
    Button,
    Checkbox,
    CheckboxGroup,
    Dialog,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Form,
    FormItem,
    Input,
    Menu,
    Submenu,
    Table,
    TableColumn,
    Tabs,
    TabPane,
    Tree,
    Tooltip,
    MenuItem,
    MenuItemGroup,
    Option,
    Pagination,
    Radio,
    RadioButton,
    RadioGroup,
    Select,
    Switch,
    Carousel,
    CarouselItem,
    Message,
    Loading,
    Cascader,
    Popover,
    Upload,
    Row,
    Col,
    DatePicker,
    Calendar,
    ButtonGroup,
    Collapse,
    CollapseItem,
    TimeSelect,
    TimePicker,
    Autocomplete,
    CascaderPanel,
    Notification,
    Image,
    Card,
    Avatar,
    MessageBox,
    Tag,
    Step,
    Steps,
    InputNumber,
    Transfer,
    Drawer,
    Divider,
} from 'element-ui';

// 指令
Vue.use(Loading.directive);
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;
Vue.prototype.$confirm = MessageBox.confirm;

// 设置语言
locale.use(lang);

const elementComponents = [
    Alert,
    Button,
    Checkbox,
    CheckboxGroup,
    Dialog,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Form,
    FormItem,
    Input,
    Menu,
    Submenu,
    Switch,
    Table,
    TableColumn,
    Tabs,
    TabPane,
    Tree,
    Tooltip,
    MenuItem,
    MenuItemGroup,
    Option,
    Pagination,
    Radio,
    RadioButton,
    RadioGroup,
    Select,
    Carousel,
    CarouselItem,
    Message,
    Cascader,
    Popover,
    Upload,
    Row,
    Col,
    DatePicker,
    Calendar,
    ButtonGroup,
    Collapse,
    CollapseItem,
    TimeSelect,
    TimePicker,
    Autocomplete,
    CascaderPanel,
    Notification,
    Image,
    Card,
    Avatar,
    MessageBox,
    Tag,
    Step,
    Steps,
    InputNumber,
    Transfer,
    Drawer,
    Divider,
];
elementComponents.forEach((component) => {
    Vue.component(component.name, component);
});
